import dayjs from 'dayjs';

/** One row per SKU the plan knows about. Mix SKUs sum their component litres back to a pack. */
export const skuCatalog = (plan) => {
  const bySku = new Map();
  (plan.beers || []).forEach((beer) => {
    (beer.skuLines || []).forEach((line) => {
      if (!line.sku) return;
      const prev = bySku.get(line.sku);
      if (!line.viaMix) {
        bySku.set(line.sku, {
          sku: line.sku,
          beerName: beer.beerName,
          productName: line.productName,
          unit: line.unit,
          litresPerUnit: line.litresPerUnit || 0,
        });
        return;
      }
      if (prev && !prev.viaMix) return;
      if (!prev) {
        bySku.set(line.sku, {
          sku: line.sku,
          beerName: line.viaMix || beer.beerName,
          productName: line.productName,
          unit: line.unit,
          litresPerUnit: line.litresPerUnit || 0,
          viaMix: true,
        });
        return;
      }
      prev.litresPerUnit += line.litresPerUnit || 0;
    });
  });
  return [...bySku.values()].sort((a, b) => (
    a.beerName.localeCompare(b.beerName) || a.sku.localeCompare(b.sku)
  ));
};

export const lineLitres = (line, catalog) => {
  const qty = Number(line.quantity);
  if (!Number.isFinite(qty)) return null;
  if (line.unit === 'litres') return qty;
  const info = catalog.find((sku) => sku.sku === line.sku);
  if (!info || !info.litresPerUnit) return null;
  return qty * info.litresPerUnit;
};

/** 'missing' = a SKU the plan does not stock or forecast. 'outside' = no overlap with the horizon. */
export const eventFlags = (event, plan, catalog) => {
  const flags = [];
  const last = (plan.weekStarts || [])[plan.weekStarts.length - 1];
  const horizonEnd = last ? dayjs(last).add(6, 'day').format('YYYY-MM-DD') : null;
  const overlaps = horizonEnd && event.startDate <= horizonEnd && event.endDate >= plan.today;
  if (!overlaps) flags.push('outside');
  const known = new Set(catalog.map((sku) => sku.sku));
  if ((event.lines || []).some((line) => !known.has(line.sku))) flags.push('missing');
  return flags;
};
